import styled from "@emotion/styled";
import { LoadingIcon, LoadingIconProps } from "@unlikelyai-magic/ui/icons";

// Default color fallback for when theme isn't available
const DEFAULT_SPINNER_COLOR = "#004B2D";

export const Spinner = styled(
  ({ size = "2rem", ...props }: LoadingIconProps) => (
    <LoadingIcon {...props} size={size} />
  )
)`
  path {
    stroke: ${({ theme, color }) =>
      color ||
      (theme as any)?.colors?.action?.primary?.default ||
      DEFAULT_SPINNER_COLOR};
  }
`;
